@defer (on viewport) {
  <app-card>
    <app-card-header title="Depósitos Pendentes">
      <div class="flex flex-1 items-center justify-between flex-wrap gap-4">
        <div>
          <p-selectbutton
            [options]="[ summaryDepositsType.INDIVIDUAL, summaryDepositsType.ACCUMULATED ]"
            [(ngModel)]="summaryDepositsShowType"
            (ngModelChange)="mountSummaryDepositsData()"
            size="small"
          >
            <ng-template let-type #item>
              <div>{{ type | summaryDepositsType }}</div>
            </ng-template>
          </p-selectbutton>
        </div>
        <div class="flex items-center justify-end gap-4">
          <p-select
            id="interval"
            variant="outlined"
            [options]="[
              summaryDepositsInterval['10M'],
              summaryDepositsInterval['30M'],
              summaryDepositsInterval['1H'],
              summaryDepositsInterval['2H'],
              summaryDepositsInterval['4H'],
            ]"
            [(ngModel)]="summaryDepositsIntervalSelected"
            (ngModelChange)="getSummaryDeposits()"
            size="small"
          >
            <ng-template let-type #item>
              <div>{{ type | summaryDepositsInterval }}</div>
            </ng-template>
            <ng-template let-type #selectedItem>
              <div class="bg-transparent">{{ type | summaryDepositsInterval }}</div>
            </ng-template>
          </p-select>
          <p-datepicker
            size="small"
            dateFormat="dd/mm/yy"
            [(ngModel)]="summaryDepositsDate"
            (ngModelChange)="getSummaryDeposits()"
            fluid
            class="w-28"
          />
          <p-button variant="text" size="small" (click)="getSummaryDeposits()">
            <i class="fa-solid fa-arrows-rotate"></i>
          </p-button>
        </div>
      </div>
    </app-card-header>

    @if (summaryDepositsLoading() && !summaryDepositsChartData()) {
      <div class="w-full h-96 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (summaryDepositsChartData()?.datasets.length) {
        <p-chart
          id="pixConversionRateIndividualChart"
          #pixConversionRateIndividualChart
          type="line"
          [data]="summaryDepositsChartData()"
          [options]="summaryDepositsChartOptions()"
          class="w-full h-[500px]"
        />
    } @else {
      <app-empty-chart />
    }
  </app-card>
} @placeholder {
  <p-skeleton height="32rem" />
}
